import { combineEpics, type Epic } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { editEventRequest } from '@/api/events';
import {
  editEvent,
  resetAllEventsForProperty,
  setCurrentEvent,
} from '../actions';

const editEventEpic: Epic = (action$) =>
  action$.pipe(
    filter(editEvent.match),
    request(({ payload }) => editEventRequest(payload), editEvent),
  );

const editEventSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(editEvent.succeeded.match),
    mergeMap(
      ({
        payload: {
          data,
          originalData: { property_id },
        },
      }) => [
        setCurrentEvent(data),
        resetAllEventsForProperty({ propertyId: property_id }),
      ],
    ),
  );

export default combineEpics(editEventEpic, editEventSucceededEpic);
